import { useBookingCartStore } from '@booking/stores/bookingCart'
import { useCompanyStore } from '@booking/stores/company'
import { ServiceTypes } from '@types'

export function useInventoryTimezone() {
  const cart = useBookingCartStore()
  const companyStore = useCompanyStore()

  return computed(() => {
    const serviceId =
      cart.firstInventoryServiceId ?? cart.inventoryItems[0]?.service.id ?? companyStore.inventoryServices[0]?.id
    const services = [...companyStore.services, ...(companyStore.company.services || [])]
    const service =
      serviceId == null
        ? services.find(service => service.type === ServiceTypes.Inventory)
        : services.find(service => service.id === serviceId)
    return (
      (serviceId != null && companyStore.serviceTimezonesById[serviceId])
      || service?.addresses?.[0]?.timezone
      || companyStore.company.addresses?.[0]?.timezone
      || ''
    )
  })
}
